import React from 'react';

export function CMSHeader({page, maxPage, setPage, context}) {


    return (
        <div className={"sticky-top bg-white border-bottom border-dark d-flex  justify-content-center align-items-center py-3"}>
            <h3 className={"me-5"}>Content Management System - {context}</h3>
            <div className={"row"}>
                <button className={"col m-2 px-4 text-white btn btn-secondary"} onClick={() => setPage(page-1 >= 0 ? page-1 : 0)}>Forrige</button>
                <label className={"col mx-2"}>Side {page+1}/{maxPage+1}</label>
                <button className={"col m-2 px-4 text-white btn btn-primary"} onClick={() => setPage(page+1 <= maxPage ? page+1 : page)}>Neste</button>
            </div>
        </div>
    );

}